module.exports = __webpack_public_path__ + "static/prodinity_main_7-82314761a4868d9d07379ef991a531d2.png";